import React from 'react';
import { GetProfileWrapper } from 'pages/profile/get-profile/GetProfile.styled';
import { Container } from 'layout/page/Page.layout.styled';
import { prem } from 'styles/helpers/spacing';
import { GenericDiv } from 'styles/helpers/utils';
import QuestionnaireButton from 'components/profile/QuestionnaireButton';

export interface GetProfileProps {
  message: string;
  btnLabel?: string;
  onClick?: () => void;
}

const GetProfile: React.FC<GetProfileProps> = ({ message, btnLabel, onClick }) => {
  return (
    <GetProfileWrapper className="app-page">
      <Container flexCentered={true}>
        <p className="message">{message}</p>
        <GenericDiv width="25%" minWidth={prem(240)} center={true}>
          <QuestionnaireButton onClick={onClick} label={btnLabel} />
        </GenericDiv>
      </Container>
    </GetProfileWrapper>
  );
};

export default GetProfile;
